var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "layerWrapper artnutri pop_artnutri_210924_03" },
      [
        _c("div", { staticClass: "cbox layerBox popWidM" }, [
          _c("div", { staticClass: "cart-popup__dialog" }, [
            _c("div", { staticClass: "cart-popup__content height-auto" }, [
              _c(
                "div",
                {
                  staticClass: "cart-popup__item-info",
                  staticStyle: { padding: "0" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "os_noticeRes",
                      attrs: { "data-btn-close": "closeLayer" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "padS txtC",
                          staticStyle: {
                            background:
                              "url(https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/bg_pop.jpg) no-repeat center / cover",
                            color: "#231f20"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "padSM padBML",
                              staticStyle: {
                                border: "2px solid rgba(255, 255, 255, 0.5)",
                                color: "#fff"
                              }
                            },
                            [
                              _c("div", [
                                _c("img", {
                                  staticStyle: {
                                    "max-width": "116px",
                                    width: "20%"
                                  },
                                  attrs: {
                                    src:
                                      "https://www.amway.co.kr/_ui/_noticeImg/2021/09/0924_arti_emptyBottle/logo_artistry_skin_nutrition_white.png",
                                    alt: "Artistry Skin Nutrition(로고)"
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "marTM fntH6 fntL" }, [
                                _c("strong", [
                                  _vm._v(
                                    "\n                                          본 이벤트는 "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "총 1회만 접수 가능합니다.\n                                      "
                                  )
                                ])
                              ])
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52f6baa3", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52f6baa3","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/waste-glass-bottle2/component/popupDup.vue
// module id = null
// module chunks = 